import { io, Socket } from 'socket.io-client'
import { STRAPI_BASE_URL } from '@/config/api'

let socket: Socket | null = null

export function getSocket(): Socket {
  if (!socket) {
    socket = io(STRAPI_BASE_URL, { autoConnect: true })
  }
  return socket
}
